export default __webpack_public_path__ + "static/media/Warning.7f947648.svg";